import { render } from "./ManageStudentOnline.vue?vue&type=template&id=1bea4d74&scoped=true"
import script from "./ManageStudentOnline.vue?vue&type=script&lang=js"
export * from "./ManageStudentOnline.vue?vue&type=script&lang=js"

import "./ManageStudentOnline.vue?vue&type=style&index=0&id=1bea4d74&scoped=true&lang=css"
import "./ManageStudentOnline.vue?vue&type=style&index=1&id=1bea4d74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bea4d74"]])

export default __exports__